interface PaginationProps {
  page: number;
  totalPages: number;
  onChange: (page: number) => void;
}

export default function Pagination({ page, totalPages, onChange }: PaginationProps) {
  if (totalPages <= 1) return null;

  const pages: number[] = [];
  for (let i = 1; i <= totalPages; i += 1) pages.push(i);

  return (
    <div className="mt-8 flex items-center justify-center gap-2">
      <button
        type="button"
        disabled={page <= 1}
        onClick={() => onChange(page - 1)}
        className="flex items-center gap-1 whitespace-nowrap rounded-md bg-background-50 px-3 py-2 text-sm font-medium text-foreground-700 ring-1 ring-background-200 transition-colors hover:bg-background-100 disabled:cursor-not-allowed disabled:opacity-40"
      >
        <i className="ri-arrow-left-s-line text-base" />
        上一页
      </button>

      <div className="flex items-center gap-1">
        {pages.map((p) => (
          <button
            key={p}
            type="button"
            onClick={() => onChange(p)}
            className={`h-9 w-9 rounded-md text-sm font-medium transition-colors ${
              p === page
                ? 'bg-primary-500 text-background-50'
                : 'bg-background-50 text-foreground-700 ring-1 ring-background-200 hover:bg-background-100'
            }`}
          >
            {p}
          </button>
        ))}
      </div>

      <button
        type="button"
        disabled={page >= totalPages}
        onClick={() => onChange(page + 1)}
        className="flex items-center gap-1 whitespace-nowrap rounded-md bg-background-50 px-3 py-2 text-sm font-medium text-foreground-700 ring-1 ring-background-200 transition-colors hover:bg-background-100 disabled:cursor-not-allowed disabled:opacity-40"
      >
        下一页
        <i className="ri-arrow-right-s-line text-base" />
      </button>
    </div>
  );
}